/** 서버 mapSession / mapItem / mapRecord 응답을 화면용으로 통일 */

function parseItemDefaultAmount(raw) {
  const v =
    raw.default_amount ??
    raw.defaultAmount ??
    raw.default_amout ??
    raw.default_amount_snapshot ??
    raw.defaultAmountSnapshot;
  if (v === null || v === undefined) return null;
  if (v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

export function normalizeSession(raw) {
  if (!raw) return raw;
  return {
    ...raw,
    id: raw.id != null && raw.id !== undefined ? String(raw.id) : raw.id,
    school_year_id: Number(raw.school_year_id),
    hierarchy_one:
      raw.hierarchy_one != null && raw.hierarchy_one !== undefined
        ? String(raw.hierarchy_one)
        : "",
    display_order: Number(raw.display_order ?? 0),
    session_name: raw.session_name ?? raw.sessionName ?? "",
    issue_date: raw.issue_date ?? raw.issueDate ?? raw.issueDateStr ?? "",
    cms_message: raw.cms_message ?? raw.cmsMessage ?? raw.cms_msg ?? "",
    unreg_message:
      raw.unreg_message ?? raw.unregMessage ?? raw.unregistered_message ?? "",
  };
}

export function normalizeItem(raw) {
  if (!raw) return raw;
  const billing_session_id =
    raw.billing_session_id ??
    raw.billingSessionId ??
    raw.session_id ??
    raw.sessionId;
  return {
    id: raw.id != null && raw.id !== undefined ? String(raw.id) : raw.id,
    billing_session_id:
      billing_session_id != null ? String(billing_session_id) : undefined,
    item_name: raw.item_name ?? raw.itemName ?? "",
    default_amount: parseItemDefaultAmount(raw),
    display_order: Number(raw.display_order ?? raw.displayOrder ?? 0),
  };
}

/** 세션/항목 id는 문자열로 통일 (API·select value와 === 매칭 실패 방지) */
export function normalizeRecord(raw) {
  if (!raw) return raw;
  const sessionId =
    raw.session_id ?? raw.billing_session_id ?? raw.billingSessionId;
  const itemId =
    raw.item_id ?? raw.billing_session_item_id ?? raw.billingSessionItemId;
  const sessionStr = sessionId == null ? sessionId : String(sessionId);
  const itemStr = itemId == null ? itemId : String(itemId);
  const username =
    raw.username ?? raw.user_name ?? raw.userName ?? raw.student_username ?? "";
  return {
    ...raw,
    username: username === "" ? "" : String(username),
    session_id: sessionStr,
    item_id: itemStr,
    billing_session_id: sessionStr,
    billing_session_item_id: itemStr,
    amount:
      raw.amount === null || raw.amount === undefined || raw.amount === ""
        ? null
        : Number(raw.amount),
    bill_remark: raw.bill_remark ?? "",
    internal_memo: raw.internal_memo ?? "",
  };
}

/** 로컬 상태·getBillingRecord에서 동일 레코드 판별 (id 타입 불일치 허용) */
export function billingRecordMatch(r, sessionId, username, itemId) {
  if (!r) return false;
  const ru = String(
    r.username ?? r.user_name ?? r.userName ?? r.student_username ?? "",
  );
  const u = String(username ?? "");
  if (ru !== u) return false;
  const sid = String(r.session_id ?? r.billing_session_id ?? "");
  const iid = String(r.item_id ?? r.billing_session_item_id ?? "");
  return sid === String(sessionId ?? "") && iid === String(itemId ?? "");
}

export function normalizeBootstrapPayload(data) {
  if (!data || typeof data !== "object") {
    return {
      sessions: [],
      sessionItems: [],
      billingRecords: [],
      flexibleDataAccountMessage: {},
    };
  }
  const sessionItemsRaw =
    data.sessionItems ?? data.session_items ?? data.billingSessionItems ?? [];
  const sessionsRaw = data.sessions ?? data.billing_sessions ?? [];
  const recordsRaw =
    data.billingRecords ?? data.billing_records ?? data.records ?? [];

  return {
    sessions: Array.isArray(sessionsRaw)
      ? sessionsRaw.map(normalizeSession)
      : [],
    sessionItems: Array.isArray(sessionItemsRaw)
      ? sessionItemsRaw.map(normalizeItem)
      : [],
    billingRecords: Array.isArray(recordsRaw)
      ? recordsRaw.map(normalizeRecord)
      : [],
    flexibleDataAccountMessage:
      data.flexibleDataAccountMessage &&
      typeof data.flexibleDataAccountMessage === "object"
        ? data.flexibleDataAccountMessage
        : {},
  };
}

/** 입력/조회: 선택한 과정(org id 문자열)에 맞는 세션만 (통합 세션 hierarchy_one "" 은 항상 포함) */
export function filterSessionsForCourse(
  sessions,
  schoolYearId,
  hierarchyOneId,
) {
  const yid = Number(schoolYearId);
  if (!schoolYearId || Number.isNaN(yid)) return [];
  const hid =
    hierarchyOneId && hierarchyOneId !== "0" ? String(hierarchyOneId) : null;
  if (!hid) return [];
  return sessions
    .filter((s) => Number(s.school_year_id) === yid)
    .filter(
      (s) =>
        String(s.hierarchy_one || "") === "" ||
        String(s.hierarchy_one) === hid,
    )
    .sort(
      (a, b) =>
        (a.display_order || 0) - (b.display_order || 0) ||
        (a.session_name || "").localeCompare(b.session_name || ""),
    );
}

export function sessionOptionLabel(session) {
  const isIntegrated = String(session.hierarchy_one || "") === "";
  return isIntegrated
    ? `${session.session_name || ""}(통합)`
    : session.session_name || "";
}

/** 설정 화면: 특정 학년도 + 과정 스코프로 세션 필터 */
export function filterSessionsForSettingsScope(
  sessions,
  schoolYearId,
  courseKey,
) {
  const yid = Number(schoolYearId);
  if (!courseKey || Number.isNaN(yid)) return [];
  const integrated = courseKey === "__INTEGRATED__";
  return sessions
    .filter((s) => Number(s.school_year_id) === yid)
    .filter((s) =>
      integrated
        ? String(s.hierarchy_one || "") === ""
        : String(s.hierarchy_one) === String(courseKey),
    )
    .sort(
      (a, b) =>
        (a.display_order || 0) - (b.display_order || 0) ||
        (a.session_name || "").localeCompare(b.session_name || ""),
    );
}
